export default __webpack_public_path__ + "static/media/undraw_empty.0dee8f5a.svg";